import { useEffect, useRef } from 'react';

import { useShouldDisplayWidthThreshold } from '~/src/common/hooks/useDom';
import { breakpoints } from '~/src/styles-constants';

export const useKeyboardArrowNav = (onClickLeft: () => void, onClickRight: () => void) => {
  const isEnabled = useRef(false);

  const isMobileScreen = !useShouldDisplayWidthThreshold(breakpoints.XL);

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft') {
        onClickLeft();
      } else if (event.key === 'ArrowRight') {
        onClickRight();
      }
    };

    if (!isMobileScreen) {
      isEnabled.current = true;
      document.addEventListener('keydown', listener);
    }

    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [onClickLeft, onClickRight, isMobileScreen]);
};
